import { AppConfigService } from "../services/app-config.service";
import { TranslationInitService } from "../../lang-translate/translation-init.service";

export function appInitializerFactory(appConfig: AppConfigService, translationInitService: TranslationInitService) {
    // Return a function that initializes the app when called.
    return() => appConfig.loadConfig();;
}   
